import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { UxService } from 'src/app/core/services/ux.service';
import { AllRoleListBaseComponent } from '~/app/open-age/directory/components/all-role-list-base.component';
import { DirectoryRoleService } from '~/app/open-age/directory/services';
import { EncryptionDecryptionService } from '~/app/services/encryptDecrypt/encryption-decryption.service';

@Component({
  selector: 'directory-all-role-list',
  templateUrl: './all-role-list.component.html',
  styleUrls: ['./all-role-list.component.css'],
})
export class AllRoleListComponent extends AllRoleListBaseComponent {
  @Input()
  view: 'table' | 'list' | 'grid' = 'table';
  dialogRef: any;
  showInactive: boolean = true;

  constructor(public dialog: MatDialog,
    service: DirectoryRoleService,
    private uxService: UxService,
    encryptDecryptService: EncryptionDecryptionService
  ) {
    super(service, uxService, encryptDecryptService);
  }

  onRemove(item): void {
    this.uxService.onConfirm().subscribe(() => {
      this.remove(item);
      this.uxService.showInfo('Deleted');
    });
  }

  changeStatus(event) {
    if (this.showInactive) {
      this.status = "inactive"
    } else {
      this.status = "active"
    }
    this.currentPageNo = 1
    this.refresh()
  }

}
